module.exports = __webpack_public_path__ + "img/cubo_arrows.b92aef29.png";